
import React from 'react';
import { enableStaticRendering } from 'mobx-react';
import RootStore from './root-store';
import UserStore from './user-store';
import PractitionerStore from './practitioner-store';
import PatientStore from './patient-store';
import ClinicStore from './clinic-store';
import PrescriptionStore from './prescription-store';
import HerbStore from './herb-store';
import LibraryStore from './library-store';
import PackageStore from './package-store';
import OptionStore from './option-store';
import BookingStore from './booking-store';
import EventStore from './event-store';
import CanvasStore from "./canvas-store";
import HicapsTerminalStore from "./hicaps-terminal-store";
import PermissionRoleStore from "./permission-role-store";
import XeroStore from "./xero-store";

type CompositeStore = {
  rootStore: RootStore,
  userStore: UserStore,
  practitionerStore: PractitionerStore,
  patientStore: PatientStore,
  clinicStore: ClinicStore,
  prescriptionStore: PrescriptionStore,
  herbStore: HerbStore,
  packageStore: PackageStore,
  optionStore: OptionStore,
  libraryStore: LibraryStore,
  bookingStore: BookingStore,
  eventStore: EventStore,
  canvasStore: CanvasStore,
  hicapsTerminalStore: HicapsTerminalStore,
  permissionRoleStore: PermissionRoleStore,
  xeroStore: XeroStore,
};

const isServer = typeof window === "undefined";
// eslint-disable-next-line react-hooks/rules-of-hooks
enableStaticRendering(isServer);

// let _stores: null | CompositeStore = null;

const initStores = () => {
  const rootStore = new RootStore();
  const initializedStores: CompositeStore = {
    rootStore,
    userStore: rootStore.userStore,
    practitionerStore: rootStore.practitionerStore,
    patientStore: rootStore.patientStore,
    clinicStore: rootStore.clinicStore,
    prescriptionStore: rootStore.prescriptionStore,
    herbStore: rootStore.herbStore,
    libraryStore: rootStore.libraryStore,
    packageStore: rootStore.packageStore,
    optionStore: rootStore.optionStore,
    bookingStore: rootStore.bookingStore,
    eventStore: rootStore.eventStore,
    canvasStore: rootStore.canvasStore,
    hicapsTerminalStore: rootStore.hicapsTerminalStore,
    permissionRoleStore: rootStore.permissionRoleStore,
    xeroStore: rootStore.xeroStore,
  };
  return initializedStores;
};

export const stores = initStores(); // _stores || initStores();

export const StoreContext = React.createContext(stores);
// @ts-ignore
export const StoreProvider = ({ children }) => <StoreContext.Provider value={stores}>{children}</StoreContext.Provider>;
